module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Kéo thả các ô vuông để cho đúng thứ tự")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-chip', {
    staticStyle: {
      "background-color": "#81D4FA"
    },
    attrs: {
      "label": "",
      "text-color": "white"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.captcha) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "drag-and-drop",
      rawName: "v-drag-and-drop:options",
      value: (_vm.options),
      expression: "options",
      arg: "options"
    }],
    staticClass: "drag-wrapper text-xs-center mt-3"
  }, [_c('ul', {
    attrs: {
      "id": "captcha"
    }
  }, _vm._l((_vm.arrCaptcha), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item-captcha",
      staticStyle: {
        "padding": "10px 15px",
        "background-color": "#81D4FA",
        "margin-right": "2px",
        "color": "#fff",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-738ec94e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-738ec94e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Captcha.vue
// module id = 532
// module chunks = 1